<template>
    <div>
        <div v-for="(item,index) in markerNameList" :key="index">
<!--            <marker-name v-if="item.properties.visible === 'visible'" :markerNameInfo="item"></marker-name>-->
            <marker-name  :markerNameInfo="item"></marker-name>
        </div>
    </div>
</template>

<script>
    import MarkerName from "./MarkerName";
    export default {
        name: "MarkerNameEntry",
        props:["markerNameList"],
        components:{
            MarkerName
        }
    }
</script>

<style scoped>

</style>
